import { Alert, AlertTitle, Button, Typography } from "@mui/material";
import { Link } from "react-router";
import useClientContext from "../../../context/useClientContext";
import { pageRoutes } from "../../../routes";

const NewsPageNotLiveAlert = () => {
  const { clientCode, hasPermissions } = useClientContext();

  return (
    <Alert severity="warning" sx={{ position: "relative" }}>
      <AlertTitle>News page is not live</AlertTitle>
      {hasPermissions(["ManageInvestorPortalSettings"]) && (
        <Button
          component={Link}
          variant="text"
          color="inherit"
          sx={{ position: "absolute", right: 12, top: 12, py: 0 }}
          to={`/${clientCode}/${pageRoutes.investorRelations}/${pageRoutes.investorPortalSettings}?tab=pages`}
          target="_blank"
          rel="noopener noreferrer"
        >
          Open Settings
        </Button>
      )}
      <Typography variant="inherit">
        For investor communications to show up on the portal, you need to set the News page to Live in Investor Portal
        Settings.
      </Typography>
    </Alert>
  );
};

export default NewsPageNotLiveAlert;
